module.exports = __webpack_public_path__ + "7e8675537e6a7c7bfd5df4aeea963aa7.gif";